var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeDropdown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 13.8334L2.75 7.00008C2.58333 6.83342 2.5 6.66675 2.5 6.41675C2.5 5.91675 2.91667 5.58341 3.33333 5.58341C3.58333 5.58341 3.75 5.66675 3.91667 5.83342L10 12.0834L16 5.83342C16.1667 5.66675 16.4167 5.58341 16.6667 5.58341C17.1667 5.58341 17.5 6.00008 17.5 6.41675C17.5 6.66675 17.4167 6.83342 17.25 7.00008L10.6667 13.8334C10.5 14.0001 10.25 14.1667 10 14.1667C9.75 14.1667 9.5 14.0001 9.33333 13.8334Z",
    fill: "url(#paint0_linear_1572_76703)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1572_76703",
    x1: 17.5167,
    y1: 9.91551,
    x2: 2.53628,
    y2: 9.73213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA8916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4D131"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDropdown);
export default __webpack_public_path__ + "static/media/Home_Dropdown.765e6e5d4fe0700d8fd55e5842923afa.svg";
export { ForwardRef as ReactComponent };